import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '../../UI/Button/Button';

import { setAmountDetails } from '../../../store/actions/index';

import HeadingH4 from '../../UI/Headings/HeadingH4/HeadingH4';

class PaymentWallets extends Component {

    componentWillMount() {
        this.props.onSetAmountDetails(null);
    }

    render() {
        return (
            <div className={`pb-4 u-borderBottomNormal`}>
                <div className={`mb-5`}>
                    <div className={`mb-2`}>
                        <HeadingH4 size={16} weight="Medium" color="Dark">Dear Customer</HeadingH4>
                    </div>
                    <h5 className={`u-fontSize13 u-fontWeightRegular u-textColorDark`}>Please click 'Pay now' to continue. You will be asked to login on next page.</h5>
                </div>
                <div className={`u-flex align-items-end justify-content-between`}>
                    <div>
                        <div>
                            <HeadingH4 size={26} weight="Medium" color="Dark">20,000</HeadingH4>
                        </div>
                        <p className={`u-fontSize13 u-textColorLight`}>By clicking on Pay Now, you are agreeing to Terms &amp; Conditions.</p>
                    </div>
                    <div>
                        <Button onClick={this.props.clicked} type="PayNow" theme="Primary" width="Block">Pay Now</Button>
                    </div>
                </div>
            </div>
        );
    }
} 

const mapDispatchToProps = dispatch => {
    return {
        onSetAmountDetails: (val) => dispatch(setAmountDetails(val))
    }
}

export default connect(null, mapDispatchToProps)(PaymentWallets);


// WEBPACK FOOTER //
// ./src/components/Payment/PaymentWallets/PaymentWallets.js